import statusCodes from 'constants/statusCodes';
import { AppState } from './types';

export const defaultClient = {
  device: 'WEB',
};

export const defaultState: AppState = {
  pageType: null,
  statusCode: statusCodes.SUCCESS,
  storeId: '',
  configFlagsFetched: true,
  run: 100,
  client: defaultClient,
  breadCrumb: [],
  isSliderOpen: false,
  showBreadcrumb: false,
};
